import { useRef } from "react";
import NewInterviewSession from "../NewInterviewSession";
import InterviewSessionList, { InterviewSessionListHandle } from "../InterviewSessionList";

const Session = () => {
  const jobIdInputRef = useRef<HTMLInputElement>(null);
  const listRef = useRef<InterviewSessionListHandle>(null);

  const handleFocusJobId = () => {
    jobIdInputRef.current?.focus();
  };

  const handleInterviewCreated = () => {
    listRef.current?.refresh();
  };

  return (
    <div
      className="session px-6 md:px-8 lg:px-[120px] py-8 flex flex-col gap-6"
      style={{
        backgroundColor: "#FBFBFB",
      }}
    >
      <NewInterviewSession ref={jobIdInputRef} onSuccess={handleInterviewCreated} />
      <InterviewSessionList ref={listRef} onCreateNew={handleFocusJobId} />
    </div>
  );
};

export default Session;
